/**
 * WawLabs search events — POST https://wa.wawlabs.com/ (JSON, fire-and-forget)
 *  1) Product list   : kullanıcı kelime yazıp arattığında (drawer submit, "tüm sonuçlar", search PLP içi arama)
 *  2) Product detail : search akışından (drawer ürünü / search PLP kartı) açılan PDP yüklendiğinde
 *  3) addtocart      : search akışında bulunan ürün sepete eklendiğinde (search PLP kartı veya PDP)
 *     bc             : search drawer banner görseline tıklandığında
 *
 * Ürün ↔ arama kelimesi eşleşmesi ürün bazında localStorage'da tutulur; ürün yeni sekmede açılsa da kaybolmaz.
 *
 * Arama inişi: Product list / bc gönderilen her linkin hedef sayfası o kelimeyle kaydedilir. Hedef sayfa açılınca
 * sayfa bu kelimeyle arama akışına girer:
 *  - search PLP  : buton metni q'nun yerine geçer (drawer'daki ilgili marka/kategori butonları)
 *  - koleksiyon / landing sayfası (drawer butonunun redirect'i): kart tıklamaları ve sepete eklemeler takip edilir
 *  - PDP (redirect doğrudan ürüne gidiyorsa): ürüne tıklanmış sayılır, Product detail gönderilir
 * Aynı sekmede yenileme / geri dönüşte sayfa kelimesi sessionStorage'dan korunur.
 *
 * Config: KROWN.settings.wawlabs_events (layout/theme.liquid)
 */
(function () {
  const STORAGE_KEY = 'karaca_wawlabs_product_keywords';
  const LANDING_STORAGE_KEY = 'karaca_wawlabs_search_landings';
  const PAGE_STORAGE_KEY = 'karaca_wawlabs_page_keywords';
  const DEVICE_OS = getDeviceOs();
  // addtocart için kelimenin ürüne bağlı kalacağı süre
  const KEYWORD_TTL_MS = 24 * 60 * 60 * 1000;
  // Tıklanan ürünün PDP'si / tıklanan linkin sayfası bu süre içinde açılırsa akışa dahil edilir (yeni sekmede sonradan açma payı)
  const DETAIL_WINDOW_MS = 30 * 60 * 1000;
  const MAX_ENTRIES = 50;

  function getConfig() {
    return (window.KROWN && KROWN.settings && KROWN.settings.wawlabs_events) || {};
  }

  // device_os: Android tarayıcı → "android_web", iOS/iPadOS tarayıcı → "ios_web", diğerleri (desktop) → "web"
  function getDeviceOs() {
    const ua = navigator.userAgent || '';
    const platform = (navigator.userAgentData && navigator.userAgentData.platform) || '';
    if (platform === 'Android' || /Android/i.test(ua)) return 'android_web';
    // iPadOS 13+ Safari kendini Macintosh olarak tanıtır; dokunmatik ekrandan ayırt edilir
    const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    if (platform === 'iOS' || /iPhone|iPad|iPod/i.test(ua) || isIpadOs) return 'ios_web';
    return 'web';
  }

  // ga: sitenin kendi domain'indeki _ga cookie değeri, olduğu gibi (örn. "GA1.1.844021234.1761200000").
  // WawLabs collector'ı da aynı değeri gönderiyor. _ga_XXXX (GS2...) session cookie'leri alınmaz;
  // birden fazla _ga görünürse ilk geçerli olan kullanılır. _ga yoksa (consent öncesi) event gönderilmez.
  // TODO: _ga yokken alternatif ID kullanılıp kullanılmayacağı consent/hukuk kararına bağlı.
  function getGa() {
    const values = document.cookie.split(/;\s*/)
      .filter(cookie => cookie.indexOf('_ga=') === 0)
      .map(cookie => decodeURIComponent(cookie.slice(4)));
    return values.find(value => /^GA\d+\.\d+\.\d+\.\d+$/.test(value)) || '';
  }

  function post(body) {
    const endpoint = getConfig().endpoint;
    if (!endpoint) return;
    try {
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        credentials: 'omit'
      }).catch(() => {});
    } catch {
      /* ignore */
    }
  }

  // gid://shopify/Product/123 | "123" | 123 → "123"
  function toProductId(value) {
    const match = String(value || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function toKeyword(value) {
    return String(value || '').trim();
  }

  function absoluteUrl(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).href;
    } catch {
      return '';
    }
  }

  function getProductUrl(handle) {
    if (!handle) return '';
    const root = String(KROWN.settings.routes.root_url || '/').replace(/\/?$/, '');
    return `${window.location.origin}${root}/products/${handle}`;
  }

  function readEntries() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const entries = raw ? JSON.parse(raw) : {};
      return entries && typeof entries === 'object' ? entries : {};
    } catch {
      return {};
    }
  }

  function writeEntries(entries) {
    const now = Date.now();
    const kept = Object.keys(entries)
      .filter(id => entries[id] && now - entries[id].ts < KEYWORD_TTL_MS)
      .sort((a, b) => entries[b].ts - entries[a].ts)
      .slice(0, MAX_ENTRIES);
    const result = {};
    kept.forEach(id => { result[id] = entries[id]; });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(result));
    } catch {
      /* ignore quota */
    }
  }

  function getEntry(productId) {
    const entry = readEntries()[productId];
    return entry && Date.now() - entry.ts < KEYWORD_TTL_MS ? entry : null;
  }

  function saveEntry(productId, keyword, clickedAt) {
    const entries = readEntries();
    entries[productId] = { kw: keyword, ts: Date.now(), clickedAt: clickedAt || 0 };
    writeEntries(entries);
  }

  function readMap(storage, key) {
    try {
      const raw = storage.getItem(key);
      const map = raw ? JSON.parse(raw) : {};
      return map && typeof map === 'object' ? map : {};
    } catch {
      return {};
    }
  }

  function writeMap(storage, key, map) {
    try {
      storage.setItem(key, JSON.stringify(map));
    } catch {
      /* ignore quota */
    }
  }

  // Sayfa anahtarı: dil ön eki atılmış path + q + filter. Diğer parametreler (language, sort, page...) yok sayılır.
  function getPageKey(url) {
    try {
      const target = new URL(url, window.location.origin);
      const path = decodeURIComponent(target.pathname).toLowerCase()
        .replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/, '')
        .replace(/\/+$/, '') || '/';
      const q = (target.searchParams.get('q') || '').trim().toLowerCase();
      const filter = (target.searchParams.get('filter') || '').toLowerCase();
      return `${path}|${q}|${filter}`;
    } catch {
      return '';
    }
  }

  // Product list gönderilen linkin hedef sayfası bu kelimeyle açılacak
  function saveLanding(url, keyword) {
    const key = getPageKey(url);
    if (!key) return;
    const now = Date.now();
    const landings = readMap(localStorage, LANDING_STORAGE_KEY);
    Object.keys(landings).forEach(k => {
      if (!landings[k] || now - landings[k].ts > DETAIL_WINDOW_MS) delete landings[k];
    });
    landings[key] = { kw: keyword, ts: now };
    writeMap(localStorage, LANDING_STORAGE_KEY, landings);
  }

  // Bu sayfa arama akışından mı açıldı? Kayıt bir kez tüketilir; aynı sekmede yenilemede sessionStorage'dan gelir.
  function resolvePageKeyword() {
    const key = getPageKey(window.location.href);
    if (!key) return { keyword: '', fresh: false };

    const landings = readMap(localStorage, LANDING_STORAGE_KEY);
    const landing = landings[key];
    const pageKeywords = readMap(sessionStorage, PAGE_STORAGE_KEY);
    if (landing && Date.now() - landing.ts <= DETAIL_WINDOW_MS) {
      delete landings[key];
      writeMap(localStorage, LANDING_STORAGE_KEY, landings);
      pageKeywords[key] = landing.kw;
      writeMap(sessionStorage, PAGE_STORAGE_KEY, pageKeywords);
      return { keyword: landing.kw, fresh: true };
    }
    return { keyword: pageKeywords[key] || '', fresh: false };
  }

  // search PLP ve PDP kendi akışını yönetir; diğer sayfalar (koleksiyon, landing) listeleme sayfasıdır
  function isListingPage() {
    const pageType = getConfig().page_type;
    return pageType !== 'search' && pageType !== 'product';
  }

  function sendEventType(type, productId, url, keyword) {
    const ga = getGa();
    if (!ga) return;
    post({
      uid: getConfig().uid,
      event: {
        product_id: productId || '',
        ga: ga,
        url: absoluteUrl(url),
        waw_keyword: keyword || '',
        device_os: DEVICE_OS,
        type: type
      }
    });
  }

  // 1) Product list
  function search(query, url) {
    const keyword = toKeyword(query);
    if (!keyword) return;
    saveLanding(url, keyword);

    const ga = getGa();
    if (!ga) return;
    post({
      enter_search: keyword,
      ga: ga,
      uid: getConfig().uid,
      url: absoluteUrl(url),
      device_os: DEVICE_OS
    });
  }

  // Search akışında bir ürüne tıklandı (drawer ürünü / search PLP kartı) — PDP'de Product detail için işaretlenir
  function productClicked(productId, query) {
    const id = toProductId(productId);
    const keyword = toKeyword(query);
    if (!id || !keyword) return;
    saveEntry(id, keyword, Date.now());
  }

  // 2) Product detail — PDP yüklendiğinde; yalnızca search akışından tıklanıp gelindiyse, tıklama başına bir kez
  function productDetail(productId, url) {
    const id = toProductId(productId);
    const entry = id ? getEntry(id) : null;
    if (!entry || !entry.clickedAt || Date.now() - entry.clickedAt > DETAIL_WINDOW_MS) return;
    saveEntry(id, entry.kw, 0);

    const ga = getGa();
    if (!ga) return;
    post({
      product_id: id,
      ga: ga,
      uid: getConfig().uid,
      url: absoluteUrl(url),
      waw_keyword: entry.kw,
      device_os: DEVICE_OS
    });
  }

  // 3) addtocart — component-product-form.js başarılı /cart/add.js yanıtıyla çağırır (tek line item).
  // Kelime önceliği: search PLP kartının kelimesi (keywordHint) → arama akışındaki listeleme sayfasının kelimesi
  // → ürünün kayıtlı kelimesi (PDP).
  function cartAdded(lineItem, keywordHint) {
    if (!lineItem || lineItem.status || !lineItem.product_id) return;
    const id = toProductId(lineItem.product_id);
    const entry = getEntry(id);
    const listingKeyword = isListingPage() ? page.keyword : '';
    const keyword = toKeyword(keywordHint) || listingKeyword || (entry ? entry.kw : '');
    if (!id || !keyword) return;
    saveEntry(id, keyword, entry ? entry.clickedAt : 0);

    const isCurrentPdp = toProductId(getConfig().product_id) === id;
    const url = isCurrentPdp
      ? window.location.origin + window.location.pathname
      : getProductUrl(lineItem.handle);
    sendEventType('addtocart', id, url, keyword);
  }

  // 3) bc — banner linki url olarak gider; product_id gönderilmez.
  // Butonlardaki gibi hedef sayfa bu kelimeyle arama akışına girer (default banner'da kelime yok → akış yok).
  function bannerClick(url, query) {
    if (!url || url === '#') return;
    const keyword = toKeyword(query);
    if (keyword) saveLanding(url, keyword);
    sendEventType('bc', '', url, keyword);
  }

  // Koleksiyon / landing sayfası arama akışındaysa: kart linkine tıklama → Product detail eşlemesi
  // (holly-collection-card: id="product-item-<productId>"). Favori butonu (click.prevent) hariç.
  function trackListingCardClick(event) {
    if (event.defaultPrevented || (event.type === 'auxclick' && event.button !== 1)) return;
    const link = event.target.closest && event.target.closest('a[href]');
    const card = link && link.closest('[id^="product-item-"][data-js-product-item]');
    if (card) productClicked(card.id, page.keyword);
  }

  const page = resolvePageKeyword();

  window.WawlabsEvents = {
    search,
    productClicked,
    productDetail,
    cartAdded,
    bannerClick,
    // search PLP: buton metniyle gelindiyse o kelime, değilse ''
    getPageKeyword: () => page.keyword
  };

  if (getConfig().product_id) {
    // Drawer butonunun redirect'i doğrudan PDP'ye gittiyse ürüne tıklanmış sayılır
    if (page.keyword && page.fresh) productClicked(getConfig().product_id, page.keyword);
    productDetail(getConfig().product_id, window.location.origin + window.location.pathname);
  }

  if (page.keyword && isListingPage()) {
    document.addEventListener('click', trackListingCardClick);
    document.addEventListener('auxclick', trackListingCardClick);
  }
})();
